import * as React from "react";

import ClassNames from "classnames";

import Styles from "./Grid.module.css";

export type ContainerProps = {
  children: any;
  variant: "container";
  alignItems?:
    | "items-start"
    | "items-end"
    | "items-center"
    | "items-baseline"
    | "items-stretch";
  containerClassName?: string;
  direction?: "row" | "column";
  innerItemClassName?: never;
  itemClassName?: never;
  justifyContent?:
    | "justify-start"
    | "justify-end"
    | "justify-center"
    | "justify-between"
    | "justify-around"
    | "justify-evenly";
  lg?: never;
  md?: never;
  order?: never;
  sm?: never;
  spacing?: 1 | 2 | 3 | 4;
  wrap?: "wrap" | "no-wrap";
  xl?: never;
  xs?: never;
};

export type ItemProps = {
  children: any;
  variant: "item";
  alignItems?: never;
  containerClassName?: never;
  direction?: never;
  innerItemClassName?: string;
  itemClassName?: string;
  justifyContent?: never;
  lg?: SpanProps;
  md?: SpanProps;
  order?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | "first" | "last";
  sm?: SpanProps;
  spacing?: never;
  wrap?: never;
  xl?: SpanProps;
  xs?: SpanProps;
};

type SpanProps = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

type CombinedProps = ContainerProps | ItemProps;

const Grid: React.FC<CombinedProps> = props => {
  const {
    children,
    variant,
    alignItems,
    containerClassName,
    direction = "row",
    innerItemClassName,
    itemClassName,
    justifyContent,
    lg,
    md,
    order,
    sm,
    spacing = 1,
    wrap = "wrap",
    xl,
    xs
  } = props;

  const isItem = variant === "item";
  const isContainer = variant === "container";

  const setRespClass = (
    breakpoint: "xs" | "sm" | "md" | "lg" | "xl",
    breakpointValue: SpanProps
  ) => {
    return breakpointValue !== 12
      ? `${breakpoint}:w-${breakpointValue}/12`
      : `${breakpoint}:w-full`;
  };

  return (
    <div
      className={ClassNames({
        [Styles[variant]]: true,
        [Styles[spacing]]: isContainer,
        [Styles[direction]]: isContainer,
        [Styles[wrap]]: isContainer,
        [alignItems]: alignItems,
        [containerClassName]: isContainer && containerClassName,
        [itemClassName]: isItem && itemClassName,
        [justifyContent]: isContainer && justifyContent,
        [setRespClass("xs", xs)]: isItem && xs,
        [setRespClass("sm", sm)]: isItem && sm,
        [setRespClass("md", md)]: isItem && md,
        [setRespClass("lg", lg)]: isItem && lg,
        [setRespClass("xl", xl)]: isItem && xl,
        [`order-${order}`]: isItem && order
      })}
    >
      {isItem ? (
        <div
          className={ClassNames({
            [innerItemClassName]: innerItemClassName
          })}
        >
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export default Grid;
